import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_CUSTOMER_PERMISSIONS } from '../../constants.tsx';
import type { RequestSecuritySettingsResponse } from './get-data/types.tsx';

export const customerPermissionsPageDataResource: RouteResource<RequestSecuritySettingsResponse> =
	createResource<RequestSecuritySettingsResponse>({
		type: RESOURCE_TYPE_CUSTOMER_PERMISSIONS,
		getKey: ({ match }) => match.params.projectKey || '',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-customer-permissions", jiraSpaEntry: "async-resource-customer-permissions" */ './get-data'
			),
		maxAge: Infinity,
	});

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports, jira/export/restrict-types-re-export
export type { RequestSecuritySettingsResponse } from './get-data/types.tsx';
